"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple in-memory mock of localForage.
 * This is used, because wkhtmltopdf does not support any persistence used by localforage and because
 * all available in-memory backends for localforage seem to cause an infinite loop.
 */
exports.default = {

  /**
   * Simple object as storage.
   */
  storage: {},

  /**
   * Sets an item in the cache.
   * @param name
   * @param value
   * @returns {Promise.<T>}
   */
  setItem: function setItem(name, value) {
    this.storage[name] = value;
    return _promise2.default.resolve();
  },


  /**
   * Gets an item from the cache.
   * @param name
   * @returns {Promise.<T>}
   */
  getItem: function getItem(name) {
    return _promise2.default.resolve(this.storage[name]);
  },


  /**
   * Removes an item from the cache.
   * @param name
   * @returns {Promise.<T>}
   */
  removeItem: function removeItem(name) {
    delete this.storage[name];
    return _promise2.default.resolve();
  },


  /**
   * Returns all cache keys.
   * @returns {Promise.<Array>}
   */
  keys: function keys() {
    return _promise2.default.resolve((0, _keys2.default)(this.storage));
  }
};